export default __webpack_public_path__ + "static/media/5836.d9d62549.svg";